import { compareMediaStreamTrack } from './media-stream-track'
import { compareUnknown } from './unknown'
export * from './types'

export const compare = <T>(a: T, b: T, ...byFieldsArg: Array<keyof T>): boolean => {
  if (a === b) {
    return true
  }
  if (a instanceof MediaStreamTrack && b instanceof MediaStreamTrack) {
    const args = byFieldsArg as Array<keyof MediaStreamTrack>
    return compareMediaStreamTrack(a, b, ...args)
  }
  return compareUnknown(a, b)
}
